import React from "react";

interface SpinnerProps {
  className?: string;
}

const Spinner = ({ className }: SpinnerProps) => {
  return <span className={`loader--spinner ${className}`}></span>;
};

export default Spinner;
